module.exports = __webpack_public_path__ + "img/tower.e6cfda8a.svg";